export default class TableOfContents {
  root;
  handler = null;
  list = null;
  page = null;
  tags = [];

  constructor(root) {
    this.root = root;
    this.handler = this.root.querySelector(".toc-list_handler");
    this.list = this.root.querySelector(".toc-list-wrapper ol");
    this.pageContent = document.querySelector(
      ".blog-post-content.blog-text-content"
    );
  }

  init = () => {
    this.tags = [
      ...this.pageContent.querySelectorAll(".content h2, .content h3"),
    ];

    console.log(this.tags);
    this.fillList();
  };

  fillList = () => {
    if (this.tags?.length == 0) this.hideListContent();
    if (!this.list) return;
    const mappedTags = this.getMappedTagWithHierarchy();

    mappedTags?.forEach((tag, index) => {
      let id = `h2-blog-anchor-${index}`;
      let content = tag.tag.textContent;
      let special_class = "";

      tag.tag.id = id;
      if (index >= 5) {
        special_class = "list_hid";
      } else {
        special_class = "list_static";
      }

      if (!this.list) return;

      const listItem = document.createElement("li");
      listItem.classList.add(special_class);
      const link = document.createElement("a");
      link.href = `#${id}`;
      link.textContent = content;
      listItem.appendChild(link);

      if (tag.children.length > 0) {
        const subList = document.createElement("ul");
        subList.classList.add("sub-list-inside");
        tag.children.forEach((child, childIndex) => {
          let childId = `h3-blog-anchor-${index}-${childIndex}`;
          let childContent = child.textContent;

          child.id = childId;

          const childListItem = document.createElement("li");
          const childLink = document.createElement("a");
          childLink.href = `#${childId}`;
          childLink.textContent = childContent;
          childListItem.appendChild(childLink);
          subList.appendChild(childListItem);
        });
        listItem.appendChild(subList);
      }

      this.list.appendChild(listItem);
    });

    if (this.tags?.length > 4) {
      this.initListHandler();
    } else {
      this.handler?.classList.add("hidden");
    }

    this.initAnchorClicks();
  };

  initListHandler = () => {
    if (!this.handler) return;

    this.handler.addEventListener("click", () => {
      if (this.handler?.classList.contains("open")) {
        this.list
          ?.querySelectorAll("li:not(.list_static)")
          .forEach((el) => el.classList.add("list_hid"));
      } else {
        this.list
          ?.querySelectorAll(".list_hid")
          .forEach((el) => el.classList.remove("list_hid"));
      }

      this.handler?.classList.toggle("open");
    });
  };

  getMappedTagWithHierarchy = () =>
    this.tags.reduce((acc, current) => {
      if (current.tagName === "H2") {
        return [...acc, { tag: current, children: [] }];
      } else if (current.tagName === "H3") {
        acc[acc.length - 1].children.push(current);
      }
      return acc;
    }, []);

  hideListContent = () => {
    this.root.classList.add("hidden");
  };

  initAnchorClicks = () => {
    if (!this.pageContent) return;
    const links = [...this.list.querySelectorAll('a[href^="#"]')].filter(
      (item) => !item.classList.contains("button")
    );

    links?.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();

        const target = event.target;
        const href = target.getAttribute("href");
        const element = document.querySelector(href);

        if (!element) return;

        const offset = +150;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      });
    });
  };
}
